export default function getAlias(state$) {
  return state$.value.page.page.aliasName
}
